import { ShieldCheck, Award, BookOpenCheck, Star } from "lucide-react";
import { useContent } from "../contexts/ContentContext";
import LeadForm from "./LeadForm";

const statIcons = [Award, BookOpenCheck, ShieldCheck];

export default function Hero() {
  const { content } = useContent();
  const h = content?.hero || {};
  if (h.enabled === false) return null;
  const stats = h.stats || [];

  return (
    <section
      id="top"
      className="relative w-full overflow-hidden pt-16 lg:pt-20"
    >
      {/* Full-bleed background image */}
      <div className="relative w-full min-h-[640px] lg:min-h-0 lg:h-[560px]">
        {h.image_url && (
          <img
            src={h.image_url}
            alt="Sunbright campus"
            className="absolute inset-0 h-full w-full object-cover"
          />
        )}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(90deg, rgba(11,20,66,0.82) 0%, rgba(11,20,66,0.5) 55%, rgba(11,20,66,0.2) 100%)",
          }}
        />

        {/* Overlay content grid */}
        <div className="relative z-10 h-full max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid lg:grid-cols-[7fr_4fr] gap-6 lg:gap-10 h-full lg:items-center py-6 lg:py-0">
            {/* LEFT — content */}
            <div className="text-white max-w-xl py-8">
              {h.badge && (
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 backdrop-blur border border-white/20 text-[11px] font-semibold tracking-wide">
                  <ShieldCheck className="h-3 w-3" />
                  {h.badge}
                </div>
              )}

              <h1 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-medium tracking-tight leading-[1.05]">
                {h.headline_top}
                <span className="block" style={{ color: "#facc15" }}>{h.headline_bottom}</span>
              </h1>

              <p className="mt-4 max-w-lg text-sm lg:text-base text-white/85 leading-relaxed">
                {h.subheadline}
              </p>

              {stats.length > 0 && (
                <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3">
                  {stats.slice(0, 3).map((s, i) => {
                    const Icon = statIcons[i] || ShieldCheck;
                    return (
                      <div key={s.label} className="flex items-center gap-2.5">
                        <Icon className="h-4 w-4 text-white/80" />
                        <div>
                          <div className="font-display text-lg font-semibold leading-none">{s.value}</div>
                          <div className="text-[10px] uppercase tracking-widest text-white/70 mt-0.5">{s.label}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {(h.image_badge_title || h.floating_badge_title) && (
                <div className="mt-5 flex flex-wrap gap-2">
                  {h.floating_badge_title && (
                    <div className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5" style={{ backgroundColor: "#facc15", color: "#0b1442" }}>
                      <Star className="h-3 w-3" strokeWidth={2.5} />
                      <span className="text-[11px] font-semibold">{h.floating_badge_title} · {h.floating_badge_value}</span>
                    </div>
                  )}
                  {h.image_badge_title && (
                    <div className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 bg-white/15 backdrop-blur border border-white/20 text-white">
                      <span className="text-[11px] font-semibold">{h.image_badge_title} · {h.image_badge_subtitle}</span>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* RIGHT — glassmorphism lead form */}
            <div
              className="relative rounded-2xl p-5 lg:p-6 border shadow-2xl"
              style={{
                background: "rgba(255,255,255,0.12)",
                borderColor: "rgba(255,255,255,0.28)",
                backdropFilter: "blur(22px) saturate(160%)",
                WebkitBackdropFilter: "blur(22px) saturate(160%)",
              }}
            >
              <div className="text-[10px] tracking-[0.22em] uppercase font-semibold text-white/90">
                Admissions Open · 2026
              </div>
              <h2 className="font-display mt-1.5 text-lg lg:text-xl font-medium tracking-tight leading-tight text-white">
                {h.form_heading || "Reserve your seat today."}
              </h2>
              <div className="mt-3">
                <LeadForm
                  variant="light"
                  glass
                  testidPrefix="hero-lead"
                  submitLabel={h.form_submit_label || "Get a call back"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
